import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import classNames from 'classnames';
import { useViewport } from '@sbt-web/hooks';
import { BottomSheet, ShortModal, Badge } from '@sbt-web/ui';
import { AchievementBadgesProps } from './types';
import { SvgIcon } from './components/SvgIcon';
import { AchievementInfosCarousel } from './components/AchievementInfosCarousel';
import { filterBadgesByCategory } from './utils/filterBadge';
import classes from './index.module.scss';
export const AchievementBadges = t0 => {
  const $ = _c(21);
  const {
    categoryId,
    data,
    className
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    isMobile
  } = useViewport();
  if (!data?.length) {
    return;
  }
  let completedBadges;
  let t1;
  let t2;
  let t3;
  if ($[0] !== categoryId || $[1] !== className || $[2] !== data) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const badgesToRender = filterBadgesByCategory(data, categoryId);
      if (!badgesToRender?.length) {
        t3 = undefined;
        break bb0;
      }
      completedBadges = badgesToRender.filter(_temp);
      if (completedBadges.length === 0) {
        t3 = undefined;
        break bb0;
      }
      if ($[7] !== className) {
        t1 = classNames(classes.container, className);
        $[7] = className;
        $[8] = t1;
      } else {
        t1 = $[8];
      }
      let t4;
      if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (badge, i) => <li key={badge.id}><Badge themed={true} inverted={true} classes={["caption", "small", classes.badge]} asChild={true}><button onClick={() => {
              setActiveIndex(i);
              setIsModalOpen(true);
            }} aria-label={`Apri il badge: ${badge.name}`}><SvgIcon iconName={badge?.icon} isInfo={false} className={classes.badgeIcon} />{badge.name}</button></Badge></li>;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      t2 = completedBadges.map(t4);
    }
    $[0] = categoryId;
    $[1] = className;
    $[2] = data;
    $[3] = completedBadges;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    completedBadges = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2) {
    t4 = <ul className={t1}>{t2}</ul>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== activeIndex || $[14] !== completedBadges || $[15] !== isMobile || $[16] !== isModalOpen) {
    t5 = isMobile ? <BottomSheet title="Scopri i badge dell'utente" open={isModalOpen} onClose={() => setIsModalOpen(false)}><AchievementInfosCarousel badges={completedBadges} activeIndex={activeIndex} /></BottomSheet> : <ShortModal open={isModalOpen} onClose={() => setIsModalOpen(false)} ariaDescription="Scopri i badge dell'utente" bodyClasses={[classes.shortModal]}><AchievementInfosCarousel badges={completedBadges} activeIndex={activeIndex} /></ShortModal>;
    $[13] = activeIndex;
    $[14] = completedBadges;
    $[15] = isMobile;
    $[16] = isModalOpen;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
function _temp(b) {
  return b?.status?.earned;
}